import React from "react";
import travel from "../assets/Screenshot (492).png";
import colorWebsite from "../assets/Screenshot (489).png";
import movie from "../assets/Screenshot (493).png";
import foodie from "../assets/Screenshot (491).png";

const Projects = () => {
  return (
    <div>
      <div>
        <div id="projects-section" className="projects">
          <h1>Projects .</h1>
        </div>
        <div className="project-div">
          <div className="project-info">
            <h2>Movie Review Landing Page .</h2>
            <p>
              Welcome to the Movie Review Landing Page! This project is
              dedicated to movie enthusiasts who want to explore and discover
              the latest movies, read reviews, and get information about their
              favorite films. The landing page provides an attractive and
              user-friendly interface for users to navigate through various
              movie categories.
            </p>
            <p>Technologies Used:</p>
            <ul>
              <li>Reactjs</li>
              <li>Bootstrap</li>
              <li>React Slick</li>
            </ul>
            <div className="project-btn">
              <a
                href="https://movie-reviews-app-neon.vercel.app/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="button-project">See Demo</button>
              </a>
              <a
                href="https://github.com/MayPhooPyaeSan/movie-landing-page"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="button-project">Source Code</button>
              </a>
            </div>
          </div>
          <div className="project-image">
            <img
              src={movie}
              alt="Movie Review Landing Page"
              className="project-img"
            />
          </div>
        </div>
        <div className="project-div">
          <div className="project-info">
            <h2>Color Palettes Website .</h2>
            <p>
              Welcome to our Colorful World! This platform is a celebration of
              vibrant hues and inspiring shades. Whether you're an artist
              seeking the perfect palette, a designer exploring new color
              trends, or just someone who finds joy in the beauty of colors,
              you've come to the right place.
            </p>
            <p>Technologies Used:</p>
            <ul>
              <li>Reactjs</li>
              <li>Bootstrap</li>
              <li>Material UI (MUI)</li>
            </ul>
            <div className="project-btn">
              <a
                href="https://boms-colorful-world.vercel.app/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="button-project">See Demo</button>
              </a>
              <a
                href="https://github.com/MayPhooPyaeSan/color-with-me"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="button-project">Source Code</button>
              </a>
            </div>
          </div>
          <div className="project-image">
            <img src={colorWebsite} alt="" className="project-img" />
          </div>
        </div>
        <div className="project-div">
          <div className="project-info">
            <h2>Travel Agency Landing Website .</h2>
            <p>
              Welcome to the Travel Agency Landing Website! This project was
              designed and developed with the goal of creating an engaging and
              visually appealing online presence for a travel agency. The
              website provides a seamless user experience, enticing visitors to
              explore various travel destinations and services offered by the
              agency.
            </p>

            <p>Technologies Used:</p>
            <ul>
              <li>Reactjs</li>
              <li>Solid CSS</li>
              <li>Material UI (MUI)</li>
              <li>Bootstrap</li>
              <li>React Slick</li>
            </ul>
            <div className="project-btn">
              <a
                href="https://travel-landing-app.vercel.app/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="button-project">See Demo</button>
              </a>
              <a
                href="https://github.com/MayPhooPyaeSan/travel-landing-page"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="button-project">Source Code</button>
              </a>
            </div>
          </div>
          <div className="project-image">
            <img src={travel} alt="" className="project-img" />
          </div>
        </div>
        <div className="project-div">
          <div className="project-info">
            <h2>Foodie POS .</h2>
            <p>
              Welcome to Foodie POS, an innovative Point of Sale (POS) system
              designed for restaurants with a modern twist! This project
              encompasses a comprehensive QR code order system, an intuitive
              admin panel, and an engaging landing page. The QR code order
              system enhances the dining experience, allowing customers to
              conveniently place orders using their smartphones.
            </p>
            <p>Technologies Used:</p>
            <ul>
              <li>Nextjs</li>
              <li>Typescript</li>
              <li>Material UI (MUI)</li>
              <li>Postgres SQL</li>
            </ul>
            <div className="project-btn">
              <a
                href="https://next-foodie-app-git-main-mayphoopyaesan.vercel.app/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="button-project">See Demo</button>
              </a>
              <a
                href="https://github.com/MayPhooPyaeSan/next-foodie-app"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="button-project">Source Code</button>
              </a>
            </div>
          </div>
          <div className="project-image">
            <img src={foodie} alt="" className="project-img" />
          </div>
        </div>
      </div>
      <a
        href="https://github.com/MayPhooPyaeSan"
        className="github-link"
        target="_blank"
      >
        See More Projects On Github.{" "}
      </a>
    </div>
  );
};

export default Projects;
